<template>
  <div>
    <v-skeleton-loader v-if="loading" />
    <v-container
      v-else
      fluid
    >
      <p class="display-2">
        {{ exportAnalysisTitle }}
      </p>
      <p class="subtitle-1">
        {{ $t('exportAnalysis.dateRange') }}
      </p>
      <v-row
        align="center"
        justify="center"
        class="d-flex-column"
      >
        <DatePicker
          :landscape="true"
          class="mt-1"
          :max="$utils.getTomorrowDate()"
          :disabled="loadingCSV"
          @change="dateRange = $event"
        />
      </v-row>
      <v-row>
        <v-btn
          class="mx-auto"
          :disabled="dateRange.length === 0"
          :loading="loadingCSV"
          @click="exportSiteAnalysisCSV"
        >
          {{ $t('csv.exportCsv') }}
          <v-icon right>
            mdi-cloud-download
          </v-icon>
        </v-btn>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import DatePicker from '@/components/shared/forms-controls/SimpleDatePicker';
import { mapGetters } from 'vuex';

export default {
    name: 'ExportAnalysisMeasure',
    components: {
        DatePicker,
    },
    data() {
        return {
            client: { ...this.$store.getters.client },
            site: { ...this.$store.getters.site },
            siteTree: [],
            componentsPerId: {},
            analysisTypesPerId: {},
            uniqueLinesComponents: [],
            dateRange: [],
            loading: true,
            loadingCSV: false,
        };
    },
    computed: {
        ...mapGetters([
            'userLang',
        ]),
        exportAnalysisTitle() {
            return `${this.site.name} - ${this.client.name}`;
        },
    },
    async created() {
        const { siteId } = this.$route.params;
        if (siteId) {
            await this.$rq.getSiteTree(siteId).then(response => {
                // get tree of site
                this.siteTree = response.data.tree;
            });
            await this.getComponentsFromTree(this.siteTree);
            await this.getAnalysisTypesPerId();
        }
        this.loading = false;
    },
    methods: {
        async getAnalysisTypesPerId() {
            const { data: { types } } = await this.$rq.getAnalysisTypes({ typeName: 'All', pagination: false });
            this.analysisTypesPerId = types.reduce((map, analysisType) => ({
                ...map,
                [analysisType.id]: analysisType,
            }), {});
        },
        async exportSiteAnalysisCSV() {
            this.loadingCSV = true;
            const startDate = new Date(this.dateRange[0]).toISOString();
            const endDate = this.dateRange[1] ? new Date(this.dateRange[1]).toISOString() : (new Date()).toISOString();
            const response = await this.$rq.exportSiteAnalysisCSV(this.$route.params.siteId,
                {
                    startDate,
                    endDate,
                });

            if (response.data && !response.data.size) {
                this.$toasted.global.toast_error({
                    message: this.$t('exportAnalysis.noResults'),
                });
            } else {
                const fileName = `exportAnalysis_${this.site.deliveryAccountNumber}_${startDate.split('T')[0]}_to_${endDate.split('T')[0]}.csv`;
                this.$utils.saveFileOnDisk(new Blob([response.data]), fileName);
            }

            this.loadingCSV = false;
        },
        getComponentsFromTree(node, networkParent) {
            node.forEach(el => {
                let networkNode = { networkParentName: '', networkParentId: '' };

                if (el.nodeType === 'Network') networkNode = { networkParentName: el.name, networkParentId: el.ref };

                if (el.nodeType === 'Component') {
                    this.componentsPerId[el.ref] = { ...el, ...networkParent, ...networkNode };
                } else if (typeof el.children !== 'undefined') this.getComponentsFromTree(el.children, networkNode);
            });
        },
    },
};
</script>
